export function createRuntimeFilteredFlowTracer(params) {
    function nowMs() {
        if (typeof performance !== "undefined" &&
            typeof performance.now === "function") {
            return performance.now();
        }
        return Date.now();
    }
    function getCurrentIsFiltered(stack) {
        if (stack.length === 0)
            return false;
        return stack[stack.length - 1] ?? false;
    }
    function popStack(stack) {
        if (stack.length === 0)
            return;
        stack.pop();
    }
    function getActionArg(functionName) {
        if (!params.isFilterModeEnabled())
            return [];
        const action = params.createFilterAction(functionName);
        return action === undefined ? [] : [action];
    }
    function logFilterSnippetLine(functionName) {
        const args = getActionArg(functionName);
        const snippet = typeof args[0] === "string" ? args[0] : undefined;
        if (!snippet)
            return;
        // Intentionally prints a copy/paste target.
        console.log(`%c${snippet}`, "font-size: 0.85em; font-weight: 400;");
    }
    const filteredHandleSet = new WeakSet();
    const activeSyncFilterStack = [];
    function enter(functionName, ...args) {
        const isFiltered = params.store.matchesName(functionName);
        activeSyncFilterStack.push(isFiltered);
        if (isFiltered) {
            const handle = {
                rawLabel: functionName,
                label: "",
                startTime: nowMs(),
                level: "off",
            };
            filteredHandleSet.add(handle);
            return handle;
        }
        const handle = params.baseTracer.enter(functionName, ...args);
        logFilterSnippetLine(functionName);
        return handle;
    }
    function exit(handle) {
        const isFiltered = filteredHandleSet.has(handle);
        popStack(activeSyncFilterStack);
        if (isFiltered)
            return;
        params.baseTracer.exit(handle);
    }
    function enterAsync(functionName, ...args) {
        const isFiltered = params.store.matchesName(functionName);
        if (isFiltered) {
            const handle = {
                rawLabel: functionName,
                label: "",
                startTime: nowMs(),
                level: "off",
            };
            filteredHandleSet.add(handle);
            return handle;
        }
        const handle = params.baseTracer.enterAsync(functionName, ...args);
        logFilterSnippetLine(functionName);
        return handle;
    }
    function exitAsync(handle) {
        if (filteredHandleSet.has(handle))
            return;
        params.baseTracer.exitAsync(handle);
    }
    function traceParameter(name, value) {
        if (getCurrentIsFiltered(activeSyncFilterStack))
            return;
        params.baseTracer.traceParameter(name, value);
    }
    function traceReturnValue(value) {
        if (getCurrentIsFiltered(activeSyncFilterStack))
            return;
        params.baseTracer.traceReturnValue(value);
    }
    function traceException(functionName, error) {
        if (getCurrentIsFiltered(activeSyncFilterStack))
            return;
        params.baseTracer.traceException(functionName, error);
    }
    function trace(...args) {
        if (getCurrentIsFiltered(activeSyncFilterStack))
            return;
        params.baseTracer.trace(...args);
    }
    function debug(...args) {
        if (getCurrentIsFiltered(activeSyncFilterStack))
            return;
        params.baseTracer.debug(...args);
    }
    void params.logger;
    return {
        enter,
        exit,
        enterAsync,
        exitAsync,
        traceParameter,
        traceReturnValue,
        traceException,
        trace,
        debug,
    };
}
